import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OffcanvasState {
  isOffcanvasOpen: boolean;
}

const initialState: OffcanvasState = {
  isOffcanvasOpen: false,
};

const offcanvasSlice = createSlice({
  name: "offcanvas",
  initialState,
  reducers: {
    toggleOffcanvas: (state) => {
      state.isOffcanvasOpen = !state.isOffcanvasOpen;
    },
    setOffcanvasOpen: (state, action: PayloadAction<boolean>) => {
      state.isOffcanvasOpen = action.payload;
    },
  },
});

export const { toggleOffcanvas, setOffcanvasOpen } = offcanvasSlice.actions;
export default offcanvasSlice.reducer;
